define("Modules/Hero", [`Module`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`],
		constructor(setup) {
			const { data } = this;
			const { items } = setup;
			let promise;

			this.assign(data, {
				items,
				selectedIndex: 0,
				transitioning: false,
				timeoutId: null, // used to store the id of the failsafe setTimeout() call
			});

			this.render();

			if (items.length < 1) {
				return;
			}

			const promises = [
				this.create({
					namespace: `Modules/SwipableList`,
					setup: {
						name: `swipableImageModule`,
						container: this.get(`[name="swipable-images"]`),
						displayArrowsOnDesktop: true,
						isSwipable: true,
						items,
						lazyLoadItems: true,
						wrapsIndeces: true,
						callbacks: {
							onItemSelectionChange: this.onItemSelectionChange,
							loadItemForIndex: this.loadItemForIndex,
						},
					},
				}),
			];

			if (items.length > 1) {
				promises.push(
					this.create({
						namespace: `Modules/DotIndexDisplay`,
						setup: {
							name: `dotIndexDisplay`,
							container: this.get(`.dots`),
							items,
						},
					})
				);
			}

			promise = this.when({
				promises,
			});

			promise = this.when({
				promise,
				spread: (swipableImageModule) => {
					const transformElementArray = this.select(
						`.item-list > .item-container > a .image`,
						swipableImageModule.container
					);

					return this.create({
						namespace: `Modules/ParallaxBlur`,
						setup: {
							name: `parallaxBlur`,
							container: this.get(`[name="parallax-blur"]`),
							transformElementArray,
							scrollContainer: document.querySelector(`.Page.Landing`),
						},
					});
				},
			});

			promise = this.when({
				promise,
				then: () => {
					this.setTimeout();
				},
			});

			return promise;
		},

		api: {
			loadItemForIndex: {
				value(target, index) {
					const { items } = this.data;
					const item = this.clone(items[index]);
					const { color, imageUrl, logoUrl, mobileImageUrl, name, opacity, titlePosition, url } = item;
					let itemElement = this.get(`a.item`, target);
					let detailsElement;
					let imageElements;

					// add extra details
					item.hasTitle = this.isString(logoUrl) || this.isString(name);
					item.hasDetails =
						(this.isInt(item.date) && this.isString(item.timezone)) ||
						this.isString(item.city) ||
						this.isString(item.state);

					if (item.hasDetails) {
						item.label = [];

						if (this.isInt(item.date)) {
							item.label.push(this.Time.format(`%m %d %Y`, item.date, item.timezone));
						}

						if (this.isString(item.venueName, 1) || this.isString(item.city, 1) || this.isString(item.state, 1)) {
							item.label.push(`at`);
						}

						if (this.isString(item.venueName, 1)) {
							let venue = item.venueName;

							if (this.isString(item.city, 1) || this.isString(item.state, 1)) {
								venue += `,`;
							}

							item.label.push(venue);
						}

						if (this.isString(item.city, 1)) {
							item.label.push(item.city);
						}

						if (this.isString(item.state, 1)) {
							item.label.push(item.state);
						}

						item.label = item.label.join(` `);
					}

					// render item
					if (!itemElement) {
						this.render({
							name: `item`,
							target,
							data: item,
						});
						itemElement = this.get(`a.item`, target);
						detailsElement = this.get(`.details`, itemElement);

						this.render({
							name: `itemDetails`,
							target: detailsElement,
							data: item,
						});

						target.appendChild(itemElement);
						imageElements = this.select(`.image`, itemElement);
					} else {
						const desktopImage = this.get(`.image.hide-mobile`, itemElement);
						const mobileImage = this.get(`.image.hide-desktop`, itemElement);

						if (this.parseInt(itemElement.getAttribute(`data-index`)) === index) {
							// already loaded
							return;
						}

						itemElement.setAttribute(`href`, url);
						detailsElement = this.get(`.details`, itemElement);
						this.removeClass(`LOWER_LEFT LOWER_CENTER LOWER_RIGHT HIDE`, itemElement);
						this.addClass(titlePosition, itemElement);

						// set images
						desktopImage.style.backgroundImage = `url(${imageUrl})`;
						if (this.isString(mobileImageUrl, 1)) {
							mobileImage.style.backgroundImage = `url(${mobileImageUrl})`;
						} else {
							mobileImage.style.backgroundImage = `url(${imageUrl})`;
						}

						this.render({
							name: `itemDetails`,
							target: detailsElement,
							data: item,
						});

						imageElements = this.select(`.image`, itemElement);
					}

					itemElement.setAttribute(`data-index`, index);
					detailsElement.style.color = color;
					this.each(imageElements, (imageElement) => {
						imageElement.style.opacity = opacity;
					});
				},
			},

			onItemSelectionChange: {
				value(index) {
					const { data, instances } = this;
					const { items } = data;

					data.selectedIndex = index;

					if (items.length > 1) {
						instances.dotIndexDisplay.selectItemAtIndex(index);
						this.setTimeout();
					}
				},
			},

			onTimeout: {
				value() {
					this.instances.swipableImageModule.onNextItem();
				},
			},

			setTimeout: {
				value() {
					const { data } = this;
					const { items, selectedIndex } = data;
					const item = items[selectedIndex];

					if (items.length <= 1) {
						return;
					}

					window.clearTimeout(data.timeoutId); // stop the timeout handler from firing
					data.timeoutId = window.setTimeout(this.onTimeout, (item.duration + 1) * 1000);
				},
			},
		},

		listeners: [
			{
				event: `touchstart`,
				matchContainer: false,
				handler() {
					window.clearTimeout(this.data.timeoutId); // stop the timeout handler from firing
				},
			},

			{
				event: `touchend`,
				matchContainer: false,
				handler(evt) {
					this.setTimeout();
				},
			},

			{
				event: `click`,
				filter: `.dot`,
				matchContainer: false,
				handler(evt) {
					const { DOM } = this;
					const target = evt.currentTarget;
					const link = DOM.closest(target, `[data-index]`);
					const index = this.parseInt(link.getAttribute(`data-index`));

					this.instances.swipableImageModule.selectItemByIndex(index);
				},
			},
		],
	});
});

define("Modules/Hero.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Hero/item"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"mobileImageUrl") : depth0), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"imageUrl") : depth0), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\" class=\"item "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"titlePosition") : depth0), depth0))
    + "\" index=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"index") : depth0), depth0))
    + "\"> <div> <div class=\"image hide-mobile\" style=\"background-image: url("
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"imageUrl") : depth0), depth0))
    + ")\"></div> <div class=\"image hide-desktop\" style=\"background-image: url("
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"mobileImageUrl") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":217},"end":{"line":1,"column":284}}})) != null ? stack1 : "")
    + ")\"></div> <div class=\"background-gradient\"></div> </div> <div class=\"details\"></div> </a>";
},"useData":true});

this["Templates"]["Modules/Hero/itemDetails"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1 class=\"name\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"logoUrl") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":35},"end":{"line":1,"column":365}}})) != null ? stack1 : "")
    + " </h1> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img name=\"logo-url\" src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"logoUrl") : depth0), depth0))
    + "\" class=\"hide-mobile\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" /> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"customLabel") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":1,"column":128},"end":{"line":1,"column":265}}})) != null ? stack1 : "")
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"hide-desktop\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"customLabel") : depth0), depth0))
    + "</span> ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":198},"end":{"line":1,"column":258}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"hide-desktop\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</span> ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"customLabel") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":1,"column":266},"end":{"line":1,"column":358}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"customLabel") : depth0), depth0))
    + "</span> ";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":319},"end":{"line":1,"column":358}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</span> ";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"label\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "</div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasTitle") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":379}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"label") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":380},"end":{"line":1,"column":436}}})) != null ? stack1 : "")
    + " <div class=\"button hide-mobile\"> <p>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"buttonLabel") : depth0), depth0))
    + "</p> </div>";
},"useData":true});

this["Templates"]["Modules/Hero/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div name=\"swipable-images\"></div> <div name=\"parallax-blur\"></div> <div class=\"dots\"></div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Hero.js.map